import React, { FC } from 'react';
import { allowAds } from 'logic/cookies/GDPR';
import { DFPSlotsProvider } from 'react-dfp';
import { ADDS_DFP_NETWORK_ID } from './ad.consts';

type Props = {
  collapseEmptyDivs?: boolean;
};

export const AdProvider: FC<Props> = ({ children, collapseEmptyDivs = false }) =>
  allowAds ? (
    <DFPSlotsProvider dfpNetworkId={ADDS_DFP_NETWORK_ID} collapseEmptyDivs={collapseEmptyDivs}>
      {children}
    </DFPSlotsProvider>
  ) : (
    <>{children}</>
  );
